import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import {
  Input,
  Select,
  Button,
  Checkbox,
  Tooltip,
  Radio,
  InputNumber,
  message,
  Form,
  Table,
  Row,
  Col,
  Spin,
  Cascader,
} from "antd";
import { ajaxApi, getMethod, newAjaxApi } from "@/server/index";
import _, { cloneDeep, filter, get, set, trim } from "lodash";
import common from "@/public/common";
import style from "./../index.module.less";
import "./common.less";
import { QuestionCircleOutlined } from "@ant-design/icons";
import {
  selectDataConversion,
  basicInformationDataConversion,
  transformSaveParams,
} from "./../utils";
import {
  getCookie,
  getCookieNew,
  getParmUrl,
  outformat,
  setCookie,
  setCookieNew,
} from "../../../public/utils";
import {
  titleObj,
  getcolumns,
  getcolumns2,
  getcolumns3,
  isNotArr,
  isNotArr2,
  claimRuletArr,
  claimhandlingmethodArr,
} from "./config";
import {
  selectOptions,
  getSomeDictionarys,
  getSomeDictionarysBy,
  getAddressUrl,
  getBankListApi,
  getFinaceAreaApi,
  getBankNumberApi,
  getRequiredFieldsApi,
  querySupplierBaseInfoApi,
  queryIsRepeatApi,
  saveSupplierBaseInfoApi,
  queryPurchaseManagersApi,
} from "./../service";
import {
  transferSelectKeysByObj,
  transferSelectKeys,
  getUniqueId,
  undefiendToNull,
} from "@/public/utils";
import { transformQueryResponse } from "./../utils";

var jw = "OverseasCompanyContainsGAT";
var jn = "WithinChinaCompany";
const SupplierInformation = (props, ref) => {
  const { getCurrent, areas, citys, supplierInfodata, disabled } = props;

  const [form] = Form.useForm();
  const [afterSaleForm] = Form.useForm();
  //字典
  const [dictionary, setDictionary] = useState({});
  const [childDictionary, setChildDictionary] = useState({});
  //发票类型
  const [invoiceTypes, setInvoiceTypes] = useState([]);
  //省市区
  const [provinceList, setprovinceList] = useState([]);
  const [cityList, setcityList] = useState(citys || []);
  const [areaList, setareaList] = useState(areas || []);
  const initContact = [
    {
      category: "BusinessContact",
      contact_name: "",
      tel: "",
      phone: "",
      email: "",
      contact_nameErr: false,
      phoneErr: false,
      emailErr: false,
    },
    {
      category: "OrderContact",
      contact_name: "",
      tel: "",
      phone: "",
      email: "",
      contact_nameErr: false,
      phoneErr: false,
      emailErr: false,
    },
  ];
  // 联系方式
  const [contact, setContact] = useState(_.cloneDeep(initContact));
  const [contactRowSelectedKeys, setcontactRowSelectedKeys] = useState([]);
  const [formParams, setformParams] = useState({});
  const [bankNameOptions, setbankNameOptions] = useState([]);
  const [GNTradeRowSelectedKeys, setGNTradeRowSelectedKeys] = useState([]);
  const [finceArea, setfinceArea] = useState([]); //银行账户下的省市字典
  const [GNTradeTableData, setGNTradeTableData] = useState([]); // 国内账户列表数据
  const [outerAccountTableData, setouterAccountTableData] = useState([]); // 外汇账户列表数据
  const [outerRowSelectedKeys, setouterRowSelectedKeys] = useState([]);

  const [loading, setloading] = useState(false);
  const [requiredObj, setrequiredObj] = useState({}); //必填字段
  const [addressArr, setAddressArr] = useState([]); //省市区树状数据
  const [purchasingManagerList, setPurchasingManagerList] = useState([]); //采购负责人列表

  //做联动逻辑判断，处罚form更新视图
  const [params, setparams] = useState({});
  //申请入驻枚举值保存
  const [enterPrise, setEnterPrise] = useState([]);
  const [enterPriseOptions, setEnterPriseOptions] = useState([]);
  const statement_mode_key = Form.useWatch("statement_mode_key", form);

  useEffect(async () => {
    setloading(true);
    try {
      //获取配置必填项
      await getRequiredFields();
      //获取省字典
      await publicProvinceCityArea(null, "province");
      //获取其他字典
      await getDicitionary();
      // 获取财务开户银行
      let res = await getBankListApi();
      setbankNameOptions(get(res, "data.data"));
      // 获取财务的省市
      await getFinaceAreaApi().then((res) => {
        setfinceArea(
          get(res, "data.data").map((item) => {
            item.districts.forEach((_item) => {
              delete _item.districts; //删除区级数据
            });
            return item;
          }),
        );
      });

      // 获取省市区树状数据（用于售后地址级联选择）
      await getAllAddress();

      // 获取采购负责人列表（首次加载，用当前 businessId）
      await fetchPurchasingManagers();

      setloading(false);
    } catch (err) {
      console.log(err);
      setloading(false);
    }
  }, []);

  // 获取采购负责人列表（根据合作对象的 businessId 查询）
  const fetchPurchasingManagers = async () => {
    try {
      const pmRes = await queryPurchaseManagersApi();
      if (get(pmRes, "data.data")) {
        setPurchasingManagerList(
          get(pmRes, "data.data").map((i) => ({
            dict_key: i.id,
            dict_name: i.name,
            dict_code: i.code,
          })),
        );
      }
    } catch (err) {
      console.log(err);
    }
  };

  //获取申请入驻的企业相关字段
  const getEnterPrise = async (text) => {
    let res = await ajaxApi({
      params: {
        account_id: getCookie("accountId") || null,
        business_name: text,
      },
      url: common.eurekaUrlDic + "/auth/can-apply/can-enterprise/query",
    });
    setEnterPriseOptions(res.data.data);
    return res.data.data;
  };

  const handleSearch = (value) => {
    if (trim(value)) {
      getEnterPrise(value);
    } else {
      setEnterPriseOptions([]);
    }
  };

  // 保证合作对象下拉里始终包含当前已选中项，避免 value 在 options 中找不到而显示原始 id
  // cur: { po_subject_code, business_name, request_business_id, business_id }
  const ensureEnterpriseOption = (cur) => {
    if (!cur || !cur.po_subject_code) return;
    setEnterPriseOptions((prev) => {
      var list = Array.isArray(prev) ? prev.slice() : [];
      var exists = _.find(list, function (item) {
        return item.po_subject_code == cur.po_subject_code;
      });
      if (!exists) {
        // 当前项不在选项列表里，构造一项并入头部
        list.unshift({
          po_subject_code: cur.po_subject_code,
          business_name: cur.business_name || "",
          request_business_id: cur.request_business_id || "",
          business_id: cur.business_id || "",
        });
      } else {
        // 已存在则补齐可能缺失的 label 等字段，确保能正确显示名称
        exists.business_name = exists.business_name || cur.business_name || "";
        exists.request_business_id =
          exists.request_business_id || cur.request_business_id || "";
        exists.business_id = exists.business_id || cur.business_id || "";
      }
      return list;
    });
  };

  const queryBaseInfo = async (dictionary, reload) => {
    try {
      const res = await querySupplierBaseInfoApi({
        supplier_code: getCookie("supplier_code") || "",
      });
      if (get(res, "data.data")) {
        var baseInfo = transformQueryResponse(get(res, "data.data"));
        // 先用回显数据里的合作对象信息，保证下拉选项含当前选中项（避免显示 id）
        ensureEnterpriseOption({
          po_subject_code: baseInfo.po_subject_code,
          business_name: baseInfo.business_name,
          request_business_id: baseInfo.request_business_id,
          business_id: getCookie("po_subject_code")
            ? Number(getCookie("po_subject_code"))
            : "",
        });
        if (getCookie("business_name")) {
          await getEnterPrise(getCookie("business_name"));
        }
        setparams(baseInfo);
        _.defer(async () => {
          //售后地址数据
          const supplierLogistics = get(baseInfo, "supplier_logistics") || {};
          console.log(baseInfo);
          //判断企业来源，获取发票类型下拉值（需在setFieldsValue之前设置）
          setInvoiceTypes(
            get(
              dictionary,
              get(baseInfo, "business_source_key") == jw
                ? "scs_invoice_type_overseas_company_contains_gat"
                : "scs_supplier_invoice_type_within_china_company",
            ),
          );
          //基本信息
          var formValues = { ...baseInfo };
          //境外企业强制覆盖发票类型和税率
          if (get(baseInfo, "business_source_key") == jw) {
            formValues.invoice_type_key = "FormInvoice";
            formValues.tax_rate = "0";
          }
          form.setFieldsValue({
            ...formValues,
            business_id: getCookie("po_subject_code")
              ? Number(getCookie("po_subject_code"))
              : "",
          });
          //联系信息
          const contactList = get(baseInfo, "supplier_contact_list") || [];
          setContact(
            contactList.length > 0 ? contactList : _.cloneDeep(initContact),
          );
          //售后信息
          if (supplierLogistics.logistics_contactor) {
            // 将 province/city/area 转换为级联选择器的值
            const cascaderValue = [];
            if (supplierLogistics.logistics_province) {
              cascaderValue.push(supplierLogistics.logistics_province);
            }
            if (supplierLogistics.logistics_city) {
              cascaderValue.push(supplierLogistics.logistics_city);
            }
            if (supplierLogistics.logistics_district) {
              cascaderValue.push(supplierLogistics.logistics_district);
            }

            afterSaleForm.setFieldsValue({
              ...supplierLogistics,
              address_cascader:
                cascaderValue.length === 3 ? cascaderValue : null,
            });
          }
          //国内账户
          setGNTradeTableData(
            _.filter(get(baseInfo, "open_bank_list"), ["account_type", 0]).map(
              (item) => {
                return { ...item, uniqueId: getUniqueId() };
              },
            ),
          );
          //外汇账户
          setouterAccountTableData(
            _.filter(get(baseInfo, "open_bank_list"), ["account_type", 1]).map(
              (item) => {
                return {
                  ...item,
                  uniqueId: getUniqueId(),
                };
              },
            ),
          );
          console.log(
            _.filter(get(baseInfo, "open_bank_list"), ["account_type", 1]).map(
              (item) => {
                return {
                  ...item,
                  uniqueId: getUniqueId(),
                };
              },
            ),
          );
          //塞联动字段下级的字典
          setChildDictionaryFun(baseInfo, dictionary);
        }, 1000);
      }
      setloading(false);
    } catch (err) {
      console.log(err);
      setloading(false);
    }
  };

  const setChildDictionaryFun = (baseInfo, dictionary) => {
    var _cloneData = _.cloneDeep(childDictionary);
    var statement_mode_key = getOptionsByChildrenBydictionary(
      dictionary,
      "statement_mode_key",
      get(baseInfo, "statement_mode_key"),
    );
    set(_cloneData, "statement_mode_key", statement_mode_key);
    var tax_rate_options;
    if (get(baseInfo, "business_source_key") == jw) {
      tax_rate_options = transferSelectKeys([
        { dict_key: "0", dict_name: "0%" },
      ]);
    } else {
      var obj = {
        petty: "scs_tax_rate_petty",
        common: "scs_tax_rate_common",
      };
      tax_rate_options =
        get(dictionary, obj[get(baseInfo, "taxpayer_category_key")]) || [];
    }
    set(_cloneData, "tax_rate", tax_rate_options);
    setChildDictionary(_cloneData);
  };

  const getOptionsByChildrenBydictionary = (dictionary, key, val) => {
    var childrenArr = _.get(
      _.filter(get(dictionary, key) || [], ["dict_key", val]),
      "0.children",
    );
    return transferSelectKeys(childrenArr);
  };

  const getRequiredFields = async () => {
    try {
      const res = await getRequiredFieldsApi();
      if (res.status === 200) {
        var requiredMap = {};
        get(res, "data.data").map((item) => {
          var { field_name, is_nullable } = item;
          set(requiredMap, field_name, is_nullable == "0");
        });
        setrequiredObj(requiredMap);
      }
    } catch (err) {
      return;
    }
  };

  // 获取省市区
  const publicProvinceCityArea = async (id, type) => {
    try {
      const res = await getMethod(getAddressUrl(id, type));
      if (res.status === 200) {
        const list = selectDataConversion(res.data);
        if (type === "province") {
          setprovinceList(list);
        }
        if (type === "city") {
          setcityList(list);
        }
        if (type === "area") {
          setareaList(list);
        }
      }
    } catch (err) {
      return [];
    }
  };

  // 获取省市区树状数据（用于售后地址级联选择）
  const getAllAddress = async () => {
    try {
      const res = await getMethod(common.scpUrl + "supplier-enter/all-area");
      if (res.status === 200) {
        const allAddress = get(res, "data.data") || [];
        if (allAddress.length > 0) {
          // 处理成树状结构
          const addressArr = [];
          allAddress.forEach((item) => {
            if (!_.find(addressArr, { name: item.province })) {
              addressArr.push({
                name: item.province,
                districts: [],
              });
            }
            const provinceTarget = _.find(addressArr, { name: item.province });
            if (!_.find(provinceTarget.districts, { name: item.city })) {
              provinceTarget.districts.push({
                name: item.city,
                districts: [],
              });
            }
            const cityTarget = _.find(provinceTarget.districts, {
              name: item.city,
            });
            if (!_.find(cityTarget.districts, { name: item.region })) {
              cityTarget.districts.push({
                name: item.region,
              });
            }
          });
          setAddressArr(addressArr);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //拿字典
  const getDicitionary = async (res) => {
    try {
      let res = await Promise.all([
        selectOptions([
          "MoneyType",
          "OperationMode",
          "ReturnDealWay",
          "CertificateType",
        ]),
        getSomeDictionarys(),
        getSomeDictionarysBy(),
      ]);
      var dictionary = {};
      dictionary = transferSelectKeysByObj({
        ...dictionary,
        ...get(res, "0.data"),
        ...get(res, "1.data.data"),
        statement_mode_key: get(res, "2.data.data"),
      });
      setDictionary(dictionary);
      //查询企业信息，回显
      if (!["null", null, undefined].includes(getCookie("supplier_code"))) {
        await queryBaseInfo(dictionary);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getTooltiphTtml = (label, key) => {
    return (
      <Tooltip title={titleObj[key]}>
        <QuestionCircleOutlined style={{ cursor: "pointer" }} />
        <span>{label}</span>
      </Tooltip>
    );
  };

  const getOptions = (key) => {
    return get(dictionary, key) || [];
  };

  const getChilrenOptions = (key) => {
    return get(childDictionary, key) || [];
  };

  const getOptionsBy = (key) => {
    //企业来源
    var business_source_key = form.getFieldValue("business_source_key");
    //纳税人分类
    var taxpayer_category = form.getFieldValue("taxpayer_category_key");
    if (key == "tax_rate") {
      // 1、境外企业（含港澳台）：税率默认为0，不可修改
      // 2、一般纳税人：单选，默认13 %，可修改（能改哪些税率可配置，默认哪个值也可配置）
      // 3、小规模纳税人：单选，无默认值，不能选择13 %（能改哪些税率可配置，默认哪个值也可配置）
      if (business_source_key == jw) {
        return transferSelectKeys([{ dict_key: "0", dict_name: "0%" }]);
      } else {
        var obj = {
          petty: "scs_tax_rate_petty",
          common: "scs_tax_rate_common",
        };
        if (taxpayer_category == "common") {
          form.setFieldsValue({ tax_rate: "0.13" });
        }
        if (taxpayer_category == "petty") {
          form.setFieldsValue({ tax_rate: null });
        }
        if (!taxpayer_category) {
          form.setFieldsValue({ tax_rate: null });
        }
        return getOptions(obj[taxpayer_category]) || [];
      }
    }
    return get(dictionary, key) || [];
  };

  const getOptionsByChildren = (key, val) => {
    var childrenArr = _.get(
      _.filter(get(dictionary, key) || [], ["dict_key", val]),
      "0.children",
    );
    return transferSelectKeys(childrenArr);
  };

  const onValuesChange = (changedValues, allValues) => {
    //监听部分字段，取下拉值，塞默认值等；
    var _cloneData = _.cloneDeep(childDictionary);
    var key = get(_.keys(changedValues), "0");
    var val = get(changedValues, key);
    setparams({ ...params, [key]: val });

    if (key == "statement_mode_key") {
      console.log(_cloneData);
      //监听结算方式改变，账期取子集的children
      var statement_mode_key = getOptionsByChildren(key, val);
      set(_cloneData, "statement_mode_key", statement_mode_key);
      setChildDictionary(_cloneData);
      form.setFieldsValue({ account_period: null });
    }

    if (["business_source_key", "taxpayer_category_key"].includes(key)) {
      //监听企业来源，纳税人类别改变，重新取税率下拉值
      set(_cloneData, "tax_rate", getOptionsBy("tax_rate"));
      setChildDictionary(_cloneData);
    }

    if (["business_source_key"].includes(key)) {
      // 发票类型：1、境外企业（含港澳台）：默认"形式发票"，不可修改值
      //          2、境内企业：清空发票类型-选项值
      if (val == jw) {
        setInvoiceTypes(
          getOptions("scs_invoice_type_overseas_company_contains_gat"),
        );
        form.setFieldsValue({
          invoice_type_key: "FormInvoice",
          tax_rate: "0",
          taxpayer_category_key: null,
        });
        addOuterTableData(true);
        setGNTradeTableData([]);
      } else {
        setInvoiceTypes(
          getOptions("scs_supplier_invoice_type_within_china_company"),
        );
        form.setFieldsValue({ invoice_type_key: null });
        addGNTTableData(true);
        delOuterTableData();
        setouterAccountTableData([]);
      }
    }

    if (
      [
        "is_cross_border",
        "operation_mode_key",
        "pro_category_list_code",
      ].includes(key)
    ) {
      {
        /* 非海淘供应商+经营产品类型（包含隐形眼镜/护理液/润眼液/医用口罩任一）：此字段显示;
        用户如果在下拉框中选择"零售"，则直接弹框:
        "医疗器械类产品，我司不接受【零售】！请确认您的经营许可证中的【经营方式】！
      */
      }
      if (
        notCrossBorderFun() &&
        isMedicalFun() &&
        form.getFieldValue("operation_mode_key") == "Retail"
      ) {
        message.error(
          "医疗器械类产品，我司不接受【零售】！请确认您的经营许可证中的【经营方式】！",
        );
        form.setFieldsValue({ operation_mode_key: null });
      }
      //隐藏许可证经营方式时，值清空
      if (!isMedicalFun() || isCrossBorderFun()) {
        form.setFieldsValue({ operation_mode_key: null });
      }
    }

    if (["is_supply_complaint"].includes(key)) {
      //是否支持无实物投诉：选择否，清空投诉方式的值
      form.setFieldsValue({ complaint_type_key: null });
    }
    if (["business_id", "supplier_name", "credit_code"].includes(key)) {
      checkIsRepeat(allValues);
    }
  };

  const isHave = (arr, filterArr) => {
    //对比两个数组是否有相交：判断filterArr是否含有arr的某个值
    return _.get(_.difference(arr, filterArr), "length") < get(arr, "length");
  };

  const notCrossBorderFun = () => {
    //不是海淘
    return form.getFieldValue("is_cross_border") === false;
  };

  const isCrossBorderFun = () => {
    //是海淘
    return form.getFieldValue("is_cross_border") === true;
  };

  const CrossBorderIsNull = () => {
    //海淘是否是null
    return (
      form.getFieldValue("is_cross_border") === undefined ||
      form.getFieldValue("is_cross_border") === null
    );
  };

  const isOverseas = () => {
    //企业类型是境外
    return form.getFieldValue("business_source_key") == jw;
  };

  const notOverseas = () => {
    //企业类型不是境外
    return form.getFieldValue("business_source_key") != jw;
  };

  const noAccountPeriod = () => {
    //不显示账期
    return (
      form.getFieldValue("statement_mode_key") &&
      !get(childDictionary, "statement_mode_key.length")
    );
  };

  const isMedicalFun = (val) => {
    //经营产品类型是医疗器械类？：（包含隐形眼镜/护理液/润眼液/医用口罩任一）
    return isHave(
      ["ContactLenses", "ContactLensSolution", "EyeDrops", "MedicalMask"],
      form.getFieldValue("pro_category_list_code"),
    );
  };

  const selectChange = (e) => {};

  const iptChange = (index, e) => {
    let name = e.target.name;
    let value = e.target.value.trim();
    var _cloneData = _.cloneDeep(contact);
    let target = _cloneData[index];
    target[name] = value;
    let newValue = e.target.value ? e.target.value.trim() : "";
    if (["phone", "contact_name", "email"].includes(name)) {
      if (!newValue) {
        target[name + "Err"] = true;
      } else {
        target[name + "Err"] = false;
      }
      if (name === "phone") {
        // if (testPhoneNum(newValue)) {
        //   target[name + "Err"] = false
        // } else {
        //   target[name + "Err"] = true
        // }
        target[name + "Err"] = testPhoneNum(newValue);
      }
      // if (name === "email") {
      //   if (testEmail(newValue)) {
      //     target[name + "Err"] = false
      //   } else {
      //     target[name + "Err"] = true
      //   }
      // }
    }
    setContact(_cloneData);
  };

  const testPhoneNum = (num) => {
    let regx = /[\u4e00-\u9fa5]/;
    return regx.test(num);
  };

  const testEmail = (val) => {
    let regx = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    return regx.test(val);
  };

  const contactSelectChange = (index, val) => {
    var _cloneData = _.cloneDeep(contact);
    let target = contact[index];
    target.category = val;
    setContact(_cloneData);
  };

  const addContact = () => {
    let ar1 = contact.map((item) => item.category);
    let arr2 = _.get(dictionary, "contact_category_dict").map(
      (item) => item.dict_key,
    );
    contact.push({
      category: _.difference(arr2, ar1)[0],
      contact_name: "",
      tel: "",
      landline: "",
      email: "",
      contact_nameErr: false,
      phoneErr: false,
      emailErr: false,
    });
    setContact(_.cloneDeep(contact));
  };

  const delContact = () => {
    contactRowSelectedKeys.forEach((item) => {
      _.remove(contact, { category: item });
    });
    setcontactRowSelectedKeys([]);
    setContact(_.cloneDeep(contact));
  };

  const addGNTTableData = (isInit) => {
    var _cloneData = _.cloneDeep(GNTradeTableData);
    if (isInit) {
      _cloneData = [];
    }
    _cloneData.push({
      uniqueId: getUniqueId(),
      bank_account: "",
      account_name: "",
      bank_name: "",
      province: "",
      province_code: null,
      city: "",
      city_code: null,
      bank_full_name: "",
      united_bank_code: "",
      bank_code: null,
      currency: "CNY",
    });
    setGNTradeTableData(_cloneData);
  };

  const delGNTTTableData = () => {
    var data = _.cloneDeep(GNTradeTableData);
    GNTradeRowSelectedKeys.forEach((item) => {
      _.remove(data, { uniqueId: item });
    });
    setGNTradeRowSelectedKeys([]);
    setGNTradeTableData(data);
  };

  const addOuterTableData = (isInit) => {
    var data = _.cloneDeep(outerAccountTableData);
    if (isInit) {
      data = [];
    }
    data.push({
      uniqueId: getUniqueId(),
      bank_account: "", // 银行账号
      account_name: "", // 账号名称
      currency: "", // 币种
      bank_full_name: "", // 开户行全称
      bank_address: "", //开户行地址
      company_address: "", // 公司地址
      swift_code: "", // SWIFT号
    });
    setouterAccountTableData(data);
  };

  const delOuterTableData = () => {
    var data = _.cloneDeep(outerAccountTableData);
    outerRowSelectedKeys.forEach((item) => {
      _.remove(data, { uniqueId: item });
    });
    setouterRowSelectedKeys([]);
    setouterAccountTableData(data);
  };

  const columns2IptChange = (index, e) => {
    try {
      let name = e.target.name;
      let value = e.target.value.trim();
      var _cloneData = _.cloneDeep(GNTradeTableData);
      let target = _cloneData[index];

      target[name] = value;
      let newValue = e.target.value ? e.target.value.trim() : "";
      if (!newValue && name == "phone") {
        target[name + "_err"] = true;
      } else {
        target[name + "_err"] = false;
      }
      setGNTradeTableData(_cloneData);
    } catch (err) {
      console.log(err);
    }
  };

  const columns2BankNameChange = (index, val) => {
    var _cloneData = _.cloneDeep(GNTradeTableData);
    let target = _cloneData[index];
    var bankInfo = val && val.split("/");
    target.bank_name = get(bankInfo, 0);
    target.opening_bank_code = get(bankInfo, 1);
    target.province = "";
    target.city = "";
    target.bank_full_name = "";
    target.united_bank_code = "";
    target.bank_name_err = false;
    setGNTradeTableData(_cloneData);
  };

  const setGNTAddress = (index, val, selectedOptions) => {
    var _cloneData = _.cloneDeep(GNTradeTableData);
    let target = _cloneData[index];
    target.province = get(val, 0);
    target.province_code = get(selectedOptions, "0.adcode");
    target.city = get(val, 1);
    target.city_code = get(selectedOptions, "1.adcode");
    target.bank_full_name = "";
    target.united_bank_code = "";
    target.bank_province_city_err = false;
    getBankFullNameAndCode(index, _cloneData);
  };

  const getBankFullNameAndCode = async (index, _cloneData) => {
    try {
      let target = _cloneData[index];
      let { province, city, bank_name } = target;
      if (province && city && bank_name) {
        setloading(true);
        var param = {
          province_name: target.province,
          city_name: target.city,
          collection_opening_bank_name: target.bank_name,
        };
        let res = await getBankNumberApi(param);
        target.bankNumberOption = _.get(res, "data.data") || [];
        setloading(false);
      }
      setGNTradeTableData(_cloneData);
    } catch (err) {
      setloading(false);
    }
  };

  //开户行全称点击获取当前下拉选项
  const getBankOptions = (index) => {
    let target = GNTradeTableData[index];
    if (!_.get(target, "bankNumberOption.length")) {
      getBankFullNameAndCode(index, _.cloneDeep(GNTradeTableData));
    }
  };

  const columns2BankFullNmeChange = (index, val) => {
    var _cloneData = _.cloneDeep(GNTradeTableData);
    let target = _cloneData[index];
    target.bank_full_name = val;
    target.bank_full_name_err = false;
    target.united_bank_code = _.find(target.bankNumberOption, {
      collectionfullopeningbank: val,
    }).bank_number;
    setGNTradeTableData(_cloneData);
  };

  const columns3IptChange = (index, e) => {
    let name = e.target.name;
    let val = e.target.value.trim();
    var cloneData = _.cloneDeep(outerAccountTableData);
    let target = cloneData[index];
    target[name] = val;
    let _val = e.target.value ? e.target.value.trim() : "";
    if (_val) {
      target[name + "_err"] = false;
    } else {
      target[name + "_err"] = true;
    }
    setouterAccountTableData(cloneData);
  };

  const setOutAccountCurency = (index, val) => {
    var cloneData = _.cloneDeep(outerAccountTableData);
    let target = cloneData[index];
    target.currency = val;
    target.currency_err = false;
    setouterAccountTableData(cloneData);
  };

  const checkBaseData = async (isnext) => {
    try {
      let baseValues = "";
      if (isnext) {
        baseValues = await form.validateFields();
      } else {
        baseValues = undefiendToNull(form.getFieldsValue(true));
      }
      var pro_category_list_code = get(baseValues, "pro_category_list_code");
      baseValues.pro_category_list = pro_category_list_code.map((item) => {
        return { pro_category_key: item };
      });
      baseValues.account_id = getCookie("accountId");
      baseValues.scs_account_id = getCookie("accountId");
      baseValues.account_phone = getCookie("phone");
      return baseValues;
    } catch (err) {
      if (isnext && _.get(err, "errorFields.length")) {
        message.error("基础信息中有必填项未填写！");
        form.scrollToField(err.errorFields[0].name[0]);
      }
    }
  };

  // 验证联系人信息
  const checkContactInfo = async () => {
    let flag = true;
    contact.forEach((item) => {
      item.contact_name = item.contact_name
        ? item.contact_name.trim()
        : item.contact_name;
      item.phone = item.phone ? item.phone.trim() : item.phone;
      item.landline = item.landline ? item.landline.trim() : item.landline;
      if (!item.phone || testPhoneNum(item.phone)) {
        item.phoneErr = true;
        flag = false;
      }
      if (!item.contact_name) {
        item.contact_nameErr = true;
        flag = false;
      }
      // if (!item.email || !testEmail(item.email)) {
      if (!item.email) {
        item.emailErr = true;
        flag = false;
      }
    });
    if (flag) {
      return _.cloneDeep(contact).map((item) => {
        var { id, category, contact_name, phone, tel, email } = item;
        return { id, category, contact_name, phone, tel, email };
      });
    } else {
      setContact(_.cloneDeep(contact));
      message.error("联系信息中有必填项未填写！");
      return null;
    }
  };

  // 验证售后信息
  const checkAfterSaleInfo = async (isnext) => {
    try {
      let values;
      if (isnext) {
        values = await afterSaleForm.validateFields();
      } else {
        values = undefiendToNull(afterSaleForm.getFieldsValue(true));
      }

      // 深拷贝，避免修改表单内部状态
      values = _.cloneDeep(values);

      // 将级联选择器的值转换为 province/city/area
      if (values.address_cascader && values.address_cascader.length === 3) {
        values.logistics_province = values.address_cascader[0];
        values.logistics_city = values.address_cascader[1];
        values.logistics_district = values.address_cascader[2];
        delete values.address_cascader;
      }

      return values;
    } catch (err) {
      if (isnext && _.get(err, "errorFields.length")) {
        message.error("售后信息中有必填项未填写！");
        form.scrollToField(err.errorFields[0].name[0]);
      }
      return null;
    }
  };

  // 验证财务表格数据
  const checkFinanceTableInfo = async (needCheck) => {
    var cloneGNTradeTableData = _.cloneDeep(GNTradeTableData);
    var cloneouterAccountTableData = _.cloneDeep(outerAccountTableData);
    // if (!_.get(cloneGNTradeTableData, "length") && !_.get(cloneouterAccountTableData, "length")) {
    //   message.error("至少有一个账户信息，请新增国内账户或者国外账户")
    //   return null
    // }
    let flag = true;
    let arr1 = [];
    let arr2 = [];
    for (const item of cloneGNTradeTableData || []) {
      let {
        id,
        bank_account,
        account_name,
        bank_name,
        province,
        province_code,
        city,
        city_code,
        bank_full_name,
        united_bank_code,
        opening_bank_code,
      } = item;
      bank_account = bank_account ? bank_account.trim() : "";
      account_name = account_name ? account_name.trim() : "";
      arr1.push({
        id,
        account_type: 0,
        pay_type: "wire_transfer",
        bank_account,
        bank_name,
        account_name,
        bank_full_name,
        united_bank_code,
        city,
        city_code,
        province,
        province_code,
        opening_bank_code,
        // 国内账户默认人民币（与 ERP 保持一致）
        currency: item.currency || "CNY",
        // 开户行编码（与 ERP 的 bank_code 一致，取 opening_bank_code）
        bank_code: opening_bank_code || null,
      });
      if (needCheck) {
        if (!bank_account) {
          item.bank_account_err = true;
          flag = false;
        }
        if (!account_name) {
          item.account_name_err = true;
          flag = false;
        }
        if (!bank_name) {
          item.bank_name_err = true;
          flag = false;
        }
        if (!province) {
          item.bank_province_city_err = true;
          flag = false;
        }
        if (!bank_full_name) {
          item.bank_full_name_err = true;
          flag = false;
        }
      }
    }
    for (const item of outerAccountTableData) {
      let {
        id,
        currency,
        bank_account,
        account_name,
        bank_address,
        company_address,
        swift_code,
        bank_full_name,
      } = item;
      bank_account = bank_account ? bank_account.trim() : "";
      account_name = account_name ? account_name.trim() : "";
      bank_full_name = bank_full_name ? bank_full_name.trim() : "";
      bank_address = bank_address ? bank_address.trim() : "";
      company_address = company_address ? company_address.trim() : "";
      swift_code = swift_code ? swift_code.trim() : "";
      arr2.push({
        id,
        account_type: 1,
        pay_type: "wire_transfer",
        currency,
        bank_account,
        account_name,
        bank_full_name,
        bank_address,
        company_address,
        swift_code,
      });
      if (needCheck) {
        if (!currency) {
          item.currency_err = true;
          flag = false;
        }
        if (!bank_account) {
          item.bank_account_err = true;
          flag = false;
        }
        if (!account_name) {
          item.account_name_err = true;
          flag = false;
        }
        if (!bank_full_name) {
          item.bank_full_name_err = true;
          flag = false;
        }
        if (!bank_address) {
          item.bank_address_err = true;
          flag = false;
        }
        if (!company_address) {
          item.company_address_err = true;
          flag = false;
        }
        if (!swift_code) {
          item.swift_code_err = true;
          flag = false;
        }
      }
    }
    if (flag) {
      return [...arr1, ...arr2];
    } else {
      setGNTradeTableData(cloneGNTradeTableData);
      setouterAccountTableData(cloneouterAccountTableData);
      return null;
    }
  };

  const checkIsRepeat = async (data) => {
    //校验是否重复，报错：入驻企业+（供应商全称/统一社会信用代码）
    var params = {
      business_id: "sigo",
      supplier_name: get(data, "supplier_name"),
      tax_number: get(data, "credit_code"),
      po_subject_code: get(data, "po_subject_code"),
    };
    if (
      params.business_id &&
      (get(params, "supplier_name") || get(params, "tax_number"))
    ) {
      try {
        let res = await queryIsRepeatApi(params);
        console.log(res);
        var supplier_code = get(res, "data.data.supplier_code");
        if (supplier_code) {
          message.error(
            "该供应商已在【入驻企业】入驻成功（编码" +
              supplier_code +
              "），不允许再次申请入驻！",
          );
          return supplier_code;
        }
        return false;
      } catch (err) {
        console.log(err);
      }
    }
  };

  const submit = async (type) => {
    var isnext = type == "next";
    let baseRes = await checkBaseData(isnext);
    if (await checkIsRepeat(baseRes)) {
      return;
    }
    var _cloneData = _.cloneDeep(formParams);
    _cloneData = { ...baseRes };
    // 采购负责人名称
    if (_cloneData.purchasing_manager_user_id) {
      var pmItem = _.find(purchasingManagerList, {
        dict_key: _cloneData.purchasing_manager_user_id,
      });
      _cloneData.purchasing_manager_user_name = pmItem ? pmItem.dict_name : "";
    }
    if (baseRes) {
      let contactRes = await checkContactInfo(isnext);
      set(_cloneData, "supplier_contact_list", contactRes);
      if (contactRes) {
        let afterSaleRes = await checkAfterSaleInfo(isnext);
        // 售后信息需要带上after_sale_contact_id
        var supplierLogistics = get(params, "supplier_logistics") || {};
        if (supplierLogistics.after_sale_contact_id) {
          afterSaleRes.after_sale_contact_id =
            supplierLogistics.after_sale_contact_id;
        }
        set(_cloneData, "supplier_logistics", afterSaleRes);
        if (afterSaleRes) {
          _cloneData.open_bank_list = await checkFinanceTableInfo(isnext);
          if (!get(_cloneData, "open_bank_list.length")) {
            message.error("请维护收款账户信息！");
            return;
          }
          setloading(true);
          try {
            _cloneData.operate_type = type;
            _cloneData.supplier_code = getCookie("supplier_code") || "";
            const newParams = transformSaveParams(_cloneData);
            let res = await saveSupplierBaseInfoApi(newParams);
            setloading(false);
            if (res.data.code == "0") {
              message.success("企业信息提交成功！");
              // 保存成功后，确保合作对象下拉含当前选中项（避免回显时显示 id）
              ensureEnterpriseOption({
                po_subject_code: _cloneData.po_subject_code,
                business_name: _cloneData.business_name,
                request_business_id: _cloneData.request_business_id,
                business_id: _cloneData.business_id,
              });
              if (res.data && res.data.data.supplier_code) {
                setCookieNew("supplier_code", res.data.data.supplier_code, 3);
              }
              if (
                ["null", null, undefined].includes(getCookie("supplier_code"))
              ) {
                window.location.href =
                  window.location.origin +
                  "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection&&supplier_code=" +
                  res.data.data.supplier_code;
              }
            } else {
              message.error(res.data.message);
            }
            getCurrent(1);
          } catch (err) {
            console.log(err);
            setloading(false);
          }
        }
      }
    }
  };

  const save = async () => {
    var _cloneData = { ...(await checkBaseData()) };
    // 采购负责人名称
    if (_cloneData.purchasing_manager_user_id) {
      var pmItem = _.find(purchasingManagerList, {
        dict_key: _cloneData.purchasing_manager_user_id,
      });
      _cloneData.purchasing_manager_user_name = pmItem ? pmItem.dict_name : "";
    }
    setloading(true);
    let contactRes = _.cloneDeep(contact).map((item) => {
      var { id, category, contact_name, phone, tel, email } = item;
      return { id, category, contact_name, phone, tel, email };
    });
    set(_cloneData, "supplier_contact_list", contactRes);
    // 售后信息需要带上after_sale_contact_id
    var afterSaleValues = _.cloneDeep(
      undefiendToNull(afterSaleForm.getFieldsValue(true)),
    );
    var supplierLogistics = get(params, "supplier_logistics") || {};
    if (supplierLogistics.after_sale_contact_id) {
      afterSaleValues.after_sale_contact_id =
        supplierLogistics.after_sale_contact_id;
    }
    // 将级联选择器的值转换为 province/city/area
    if (
      afterSaleValues.address_cascader &&
      afterSaleValues.address_cascader.length === 3
    ) {
      afterSaleValues.logistics_province = afterSaleValues.address_cascader[0];
      afterSaleValues.logistics_city = afterSaleValues.address_cascader[1];
      afterSaleValues.logistics_district = afterSaleValues.address_cascader[2];
      delete afterSaleValues.address_cascader;
    }
    set(_cloneData, "supplier_logistics", afterSaleValues);
    set(_cloneData, "open_bank_list", await checkFinanceTableInfo(false));
    try {
      _cloneData.operate_type = "save";
      _cloneData.supplier_code = getCookie("supplier_code") || "";
      const newParams = transformSaveParams(_cloneData);
      let res = await saveSupplierBaseInfoApi(newParams);
      setloading(false);
      if (res.data.code == "0") {
        message.success("企业信息保存成功！");
        // 保存成功后，确保合作对象下拉含当前选中项（避免回显时显示 id）
        ensureEnterpriseOption({
          po_subject_code: _cloneData.po_subject_code,
          business_name: _cloneData.business_name,
          request_business_id: _cloneData.request_business_id,
          business_id: _cloneData.business_id,
        });
        if (res.data && res.data.data.supplier_code) {
          setCookieNew("supplier_code", res.data.data.supplier_code, 3);
        }
        if (["null", null, undefined].includes(getCookie("supplier_code"))) {
          window.location.href =
            window.location.origin +
            "/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection&&supplier_code=" +
            res.data.data.supplier_code;
        }
      } else {
        message.error(res.data.message);
      }
    } catch (err) {
      console.log(err);
      setloading(false);
    }
  };

  // 暴露给父组件底部按钮调用，返回 Promise 以支持按钮 loading
  useImperativeHandle(ref, () => ({
    // 保存
    save: () => {
      return new Promise((resolve, reject) => {
        // 用标志位记录是否已结算过（reject/resolve），避免原逻辑里多处 return 重复结算
        let settled = false;
        const originSave = save;
        // 直接复用原 save；save 内部不抛错，故 resolve；
        // 但 save 在校验失败（checkBaseData 抛错）时会进 catch，需 reject
        originSave().then(() => {
          if (!settled) { settled = true; resolve(); }
        }).catch((e) => {
          if (!settled) { settled = true; reject(e); }
        });
      });
    },
    // 下一步（提交）
    submit: () => {
      return new Promise((resolve, reject) => {
        let settled = false;
        submit("next").then(() => {
          if (!settled) { settled = true; resolve(); }
        }).catch((e) => {
          if (!settled) { settled = true; reject(e); }
        });
      });
    },
  }));

  const rowSelection = {
    selectedRowKeys: contactRowSelectedKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setcontactRowSelectedKeys(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: ["BusinessContact", "OrderContact"].includes(record.category),
    }),
  };
  const getRequiredIcon = (label, isRquired) => {
    return (
      <span>
        {isRquired && <span style={{ color: "red" }}>*</span>}
        {label}
      </span>
    );
  };

  const GNTradeRowSelection = {
    selectedRowKeys: GNTradeRowSelectedKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setGNTradeRowSelectedKeys(selectedRowKeys);
    },
  };
  const outerRowSelection = {
    selectedRowKeys: outerRowSelectedKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setouterRowSelectedKeys(selectedRowKeys);
    },
  };

  return (
    <Spin spinning={loading}>
      <div className={style.total_title + " companyInfo"}>
        {/* 第一个卡片:选择合作对象 */}
        <div className={style.section_card}>
          <div className={style.section_header}>
            <div className={style.section_number}>1</div>
            <div className={style.section_title}>选择合作对象</div>
          </div>
          <Form
            className="twoRow"
            form={form}
            name="basic"
            style={{}}
            onFinish={(values) => {
              console.log("Received values of form: ", values);
            }}
            onValuesChange={onValuesChange}
            autoComplete="off"
          >
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  name="po_subject_code"
                  label="合作对象"
                  rules={[
                    {
                      required: true,
                      message: "请填写你想要合作的视客公司名称",
                    },
                  ]}
                >
                  <Select
                    placeholder="请填写你想要合作的视客公司名称"
                    style={{ width: 380 }}
                    allowClear
                    showSearch
                    fieldNames={{
                      label: "business_name",
                      value: "po_subject_code",
                    }}
                    onSearch={handleSearch}
                    filterOption={false}
                    notFoundContent={null}
                    options={enterPriseOptions}
                    disabled={disabled}
                    onChange={(e, option) => {
                      if (e) {
                        form.setFieldsValue({
                          business_name: option.business_name,
                          business_id: option.business_id,
                          request_business_id: option.request_business_id,
                        });
                        setCookieNew(
                          "businessId",
                          option.request_business_id,
                          3,
                        );
                      } else {
                        form.setFieldsValue({
                          business_name: "",
                          business_id: "",
                          request_business_id: "",
                        });
                        setCookieNew("businessId", "sigo", 3);
                      }
                      // 合作对象变更后，重新查询采购负责人列表
                      form.setFieldsValue({ purchasing_manager_user_id: undefined });
                      fetchPurchasingManagers();
                    }}
                  ></Select>
                </Form.Item>
                <Form.Item
                  style={{ display: "none" }}
                  name="request_business_id"
                ></Form.Item>
                <Form.Item
                  style={{ display: "none" }}
                  name="business_name"
                ></Form.Item>
                <Form.Item
                  style={{ display: "none" }}
                  name="business_id"
                ></Form.Item>
              </Col>
            </Row>
          </Form>
        </div>

        {/* 第二个卡片:企业基础信息 */}
        <div className={style.section_card}>
          <div className={style.section_header}>
            <div className={style.section_number}>2</div>
            <div className={style.section_title}>
              企业信息
              <span className={style.section_subtitle}>(请填贵司资料)</span>
            </div>
          </div>
          <div className={style.sub_section}>
            <span className={style.sub_section_title}>基础信息</span>
          </div>
          <Form
            className="twoRow"
            form={form}
            name="basic"
            style={{}}
            onFinish={(values) => {
              console.log("Received values of form: ", values);
            }}
            onValuesChange={onValuesChange}
            autoComplete="off"
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="supplier_name"
                  label="供应商法定全称"
                  rules={[
                    {
                      required: get(requiredObj, "supplier_name"),
                    },
                  ]}
                >
                  <Input
                    style={{ width: 380 }}
                    disabled={disabled}
                    allowClear
                    placeholder="请输入供应商法定全称"
                    maxLength={50}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="legal"
                  label="法定代表人"
                  rules={[
                    {
                      required: get(requiredObj, "legal"),
                    },
                  ]}
                >
                  <Input
                    style={{ width: 380 }}
                    disabled={disabled}
                    allowClear
                    placeholder="请填写"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="business_source_key"
                  label="企业来源"
                  rules={[
                    {
                      required: get(requiredObj, "business_source_key"),
                      message: "请选择" + "企业来源",
                    },
                  ]}
                >
                  <Radio.Group
                    options={getOptions("business_source")}
                    allowClear
                    disabled={disabled}
                  ></Radio.Group>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  //  shouldUpdate={(prevValues, curValues) => curValues.business_source_key=='WithinChinaCompany'}
                  name="money_type_key"
                  label={getRequiredIcon(
                    "注册资本",
                    form.getFieldValue("business_source_key") == jw
                      ? false
                      : get(requiredObj, "money_type_key"),
                  )}
                >
                  <Form.Item
                    name={"money_type_key"}
                    // dependencies={['business_source_key']}
                    rules={[
                      {
                        required:
                          form.getFieldValue("business_source_key") == jw
                            ? false
                            : get(requiredObj, "money_type_key"),
                        message: "请输入注册资本币种",
                      },
                    ]}
                    noStyle
                  >
                    <Select
                      placeholder="请选择"
                      disabled={disabled}
                      allowClear
                      style={{ width: 140 }}
                      options={getOptions("moneytype")}
                    ></Select>
                  </Form.Item>
                  <Form.Item
                    name={"registered_capital"}
                    noStyle
                    // dependencies={['business_source_key']}
                    rules={[
                      {
                        required:
                          form.getFieldValue("business_source_key") == jw
                            ? false
                            : get(requiredObj, "registered_capital"),
                        message: "请输入注册资本金额",
                      },
                    ]}
                  >
                    <InputNumber
                      style={{ width: 240 }}
                      min={0}
                      max={9999999999}
                      disabled={disabled}
                      allowClear
                      placeholder="例如 1000"
                      allowclear
                      addonAfter="万"
                    />
                  </Form.Item>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="address"
                  label="注册地址"
                  rules={[
                    {
                      required: get(requiredObj, "address"),
                    },
                  ]}
                >
                  <Input
                    style={{ width: 380 }}
                    disabled={disabled}
                    allowClear
                    placeholder="营业执照上的注册地址"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="credit_code"
                  label="统一社会信用代码"
                  rules={[
                    {
                      required: get(requiredObj, "credit_code"),
                    },
                  ]}
                >
                  <Input
                    placeholder="18位代码"
                    style={{ width: 380 }}
                    disabled={disabled}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="manage_property_key"
                  label={getTooltiphTtml("合作模式", "manage_property_key")}
                  rules={[
                    {
                      required: get(requiredObj, "manage_property_key"),
                      message: "请选择合作模式",
                    },
                  ]}
                >
                  <Select
                    placeholder={titleObj["manage_property_key"]}
                    allowClear
                    disabled={disabled}
                    style={{ width: 380 }}
                    options={getOptions("manage_properties_dict")}
                  ></Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="is_cross_border"
                  label="是否海淘供应商"
                  rules={[
                    {
                      required: get(requiredObj, "is_cross_border"),
                      message: "请选择" + "是否海淘供应商",
                    },
                  ]}
                >
                  <Select
                    placeholder="请选择"
                    style={{ width: 380 }}
                    allowClear
                    options={isNotArr}
                    disabled={disabled}
                  ></Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="pro_category_list_code"
                  label="经营产品类型"
                  rules={[
                    {
                      required: get(requiredObj, "pro_category_key"),
                      message: "请选择" + "经营产品类型",
                    },
                  ]}
                >
                  <Checkbox.Group
                    style={{ width: 440 }}
                    allowClear
                    options={getOptions("pro_category_dict")}
                    disabled={disabled}
                  ></Checkbox.Group>
                </Form.Item>
              </Col>
              {/* 非海淘供应商+经营产品类型（包含隐形眼镜/护理液/润眼液/医用口罩任一）：此字段显示;
              用户如果在下拉框中选择"零售"，则直接弹框:
              "医疗器械类产品，我司不接受【零售】！请确认您的经营许可证中的【经营方式】！ */}
              {(CrossBorderIsNull() ||
                (notCrossBorderFun() && isMedicalFun())) && (
                <Col span={12}>
                  <Form.Item
                    name="operation_mode_key"
                    label={getTooltiphTtml(
                      "许可证经营方式",
                      "operation_mode_key",
                    )}
                    rules={[
                      {
                        required: true,
                        message: "请选择" + "许可证经营方式",
                      },
                    ]}
                  >
                    <Select
                      placeholder={titleObj["operation_mode_key"]}
                      style={{ width: 380 }}
                      allowClear
                      disabled={disabled}
                      options={getOptions("scs_operation_mode")}
                    ></Select>
                  </Form.Item>
                </Col>
              )}
              {/* 1、境外企业（含港澳台）：此字段隐藏，无需录入;
              境内企业：字段显示，单选，值可配置：一般纳税人/小规模纳税人 */}
              {notOverseas() && (
                <Col span={12}>
                  <Form.Item
                    name="taxpayer_category_key"
                    label="纳税人分类"
                    rules={[
                      {
                        required: get(requiredObj, "taxpayer_category_key"),
                      },
                    ]}
                  >
                    <Select
                      placeholder="请选择"
                      style={{ width: 380 }}
                      allowClear
                      disabled={disabled}
                      options={getOptions("scs_taxpayer_category_dict")}
                    ></Select>
                  </Form.Item>
                </Col>
              )}

              {/* 发票类型：
                1、境外企业（含港澳台）：默认"形式发票"，不可修改
                2、境内企业：单选，值可配置（增值税专用发票/增值税普通发票）
                税率：
                1、境外企业（含港澳台）：税率默认为0，不可修改
                2、一般纳税人：单选，默认13%，可修改（能改哪些税率可配置，默认哪个值也可配置）
                3、小规模纳税人：单选，无默认值，不能选择13%（能改哪些税率可配置，默认哪个值也可配置）
              */}
              <Col span={12}>
                <Form.Item
                  name="address"
                  label={getRequiredIcon(
                    "发票类型/税率",
                    get(requiredObj, "invoice_type_key") ||
                      get(requiredObj, "tax_rate"),
                  )}
                >
                  <Input.Group compact>
                    <Form.Item
                      name={"invoice_type_key"}
                      rules={[
                        {
                          required: get(requiredObj, "invoice_type_key"),
                          message: "请选择发票类型",
                        },
                      ]}
                      noStyle
                    >
                      <Select
                        disabled={isOverseas() || disabled}
                        allowClear
                        placeholder="请选择"
                        style={{ width: 190 }}
                        options={invoiceTypes}
                      ></Select>
                    </Form.Item>
                    <Form.Item
                      name={"tax_rate"}
                      noStyle
                      rules={[
                        {
                          required: get(requiredObj, "tax_rate"),
                          message: "请选择税率",
                        },
                      ]}
                    >
                      <Select
                        placeholder="请选择"
                        disabled={isOverseas() || disabled}
                        allowClear
                        style={{ width: 190 }}
                        options={getChilrenOptions("tax_rate")}
                      ></Select>
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="statement_mode_key1"
                  label={getRequiredIcon(
                    getTooltiphTtml(
                      "结算方式/账期/计算口径",
                      "statement_mode_key",
                    ),
                    get(requiredObj, "statement_mode_key"),
                  )}
                >
                  <Input.Group compact>
                    <Form.Item
                      name={"statement_mode_key"}
                      rules={[
                        {
                          required: get(requiredObj, "statement_mode_key"),
                          message: "请选择结算方式",
                        },
                      ]}
                      noStyle
                    >
                      <Select
                        placeholder="请选择"
                        disabled={disabled}
                        allowClear
                        style={
                          noAccountPeriod()
                            ? { width: 380 }
                            : [
                                  "MonthStatement",
                                  "RollToNext",
                                  "QuarterStatement",
                                ].includes(
                                  form.getFieldValue("statement_mode_key"),
                                )
                              ? { width: 100 }
                              : { width: 190 }
                        }
                        options={getOptions("statement_mode_key")}
                        onSelect={selectChange}
                      ></Select>
                    </Form.Item>
                    {!noAccountPeriod() && (
                      <Form.Item
                        name={"account_period"}
                        noStyle
                        rules={[
                          {
                            required: get(requiredObj, "account_period"),
                            message: "请选择账期",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          disabled={disabled}
                          placeholder="请选择"
                          style={
                            [
                              "MonthStatement",
                              "RollToNext",
                              "QuarterStatement",
                            ].includes(form.getFieldValue("statement_mode_key"))
                              ? { width: 100 }
                              : { width: 190 }
                          }
                          options={
                            get(childDictionary, "statement_mode_key") || []
                          }
                        ></Select>
                      </Form.Item>
                    )}
                    {[
                      "MonthStatement",
                      "RollToNext",
                      "QuarterStatement",
                    ].includes(form.getFieldValue("statement_mode_key")) && (
                      <Form.Item
                        name={"compute_standard"}
                        noStyle
                        rules={[{ required: true, message: "请选择计算口径" }]}
                      >
                        <Select
                          allowClear
                          disabled={disabled}
                          placeholder="从什么时候开始计算"
                          style={{ width: 200 }}
                          options={
                            getOptions("supplier_compute_standard_dict") || []
                          }
                        ></Select>
                      </Form.Item>
                    )}
                  </Input.Group>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="settlement_money_type_key"
                  label="结算币种"
                  rules={[
                    { required: get(requiredObj, "settlement_money_type_key") },
                  ]}
                >
                  <Select
                    allowClear
                    disabled={disabled}
                    placeholder="请选择"
                    style={{ width: 380 }}
                    options={getOptions("currency_dict")}
                  ></Select>
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="purchase_cycle"
                  label={getRequiredIcon(
                    getTooltiphTtml("生产周期", "purchase_cycle"),
                    get(requiredObj, "purchase_cycle"),
                  )}
                  rules={[
                    {
                      required: get(requiredObj, "purchase_cycle"),
                      message: "请选择" + "生产周期",
                    },
                  ]}
                >
                  <InputNumber
                    allowClear
                    disabled={disabled}
                    min={0}
                    style={{ width: 380 }}
                    placeholder={titleObj["purchase_cycle"]}
                    addonAfter="天"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="estimate_date"
                  label={getTooltiphTtml("发货天数", "estimate_date")}
                  rules={[
                    {
                      required: get(requiredObj, "estimate_date"),
                      message: "请选择" + "发货天数",
                    },
                  ]}
                >
                  <InputNumber
                    allowClear
                    disabled={disabled}
                    min={0}
                    style={{ width: 380 }}
                    placeholder={titleObj["estimate_date"]}
                    addonAfter="天"
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="purchasing_manager_user_id"
                  label="对接的采购员"
                  rules={[
                    {
                      required: true,
                      message: "请选择对接的采购员",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    optionLabelProp="label"
                    allowClear
                    placeholder="请选择"
                    style={{ width: 380 }}
                    disabled={disabled}
                    onDropdownVisibleChange={(open) => {
                      if (open) {
                        fetchPurchasingManagers();
                      }
                    }}
                  >
                    {purchasingManagerList.length > 0 &&
                      purchasingManagerList.map((item) => {
                        return (
                          <Select.Option
                            key={item.dict_key}
                            value={item.dict_key}
                            label={item.dict_name}
                          >
                            <Tooltip title={item.dict_code} placement="right">
                              {item.dict_name}
                            </Tooltip>
                          </Select.Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="is_supply_complaint"
                  label={getRequiredIcon(
                    "无实物投诉",
                    get(requiredObj, "is_supply_complaint"),
                  )}
                >
                  <Input.Group compact>
                    <Form.Item
                      name="is_supply_complaint"
                      noStyle
                      rules={[
                        {
                          required: get(requiredObj, "is_supply_complaint"),
                          message: "请选择投诉处理方式！",
                        },
                      ]}
                    >
                      <Select
                        allowClear
                        placeholder="请选择"
                        style={{ width: 190 }}
                        options={isNotArr2}
                        disabled={disabled}
                      ></Select>
                    </Form.Item>
                    {["has_goods_complaint", "no_goods_complaint"].includes(
                      form.getFieldValue("is_supply_complaint"),
                    ) && (
                      <Form.Item
                        name="claim_rule"
                        noStyle
                        rules={[
                          {
                            required: get(requiredObj, "claim_rule"),
                            message: "请选择投诉索赔规则",
                          },
                        ]}
                      >
                        <Select
                          placeholder="请选择"
                          disabled={disabled}
                          allowClear
                          style={{ width: 190 }}
                          options={claimRuletArr}
                        ></Select>
                      </Form.Item>
                    )}
                    {["has_goods_complaint", "no_goods_complaint"].includes(
                      form.getFieldValue("is_supply_complaint"),
                    ) && (
                      <Form.Item
                        name="claim_handling_method"
                        noStyle
                        rules={[
                          {
                            required: get(requiredObj, "claim_handling_method"),
                            message: "请选择投诉处理方式！",
                          },
                        ]}
                      >
                        <Select
                          allowClear
                          placeholder="请选择"
                          style={{ width: 100 }}
                          options={claimhandlingmethodArr}
                          disabled={disabled}
                        ></Select>
                      </Form.Item>
                    )}
                  </Input.Group>
                </Form.Item>
              </Col>
            </Row>
          </Form>

          <div className={style.sub_section}>
            <span className={style.sub_section_title}>联系信息</span>
          </div>
          {/* 默认展示两个联系人类别，其他的可添加 ;邮箱:校验合法性*/}
          <div style={{ marginBottom: "12px" }}>
            <Table
              rowSelection={rowSelection}
              rowKey={"category"}
              title={() => (
                <div>
                  <Button
                    type="link"
                    disabled={
                      contact.length >=
                        _.get(dictionary, "contact_category_dict.length") ||
                      disabled
                    }
                    onClick={addContact}
                  >
                    添加其他联系人
                  </Button>
                  <Button
                    type="link"
                    disabled={
                      !_.get(contactRowSelectedKeys, "length") || disabled
                    }
                    onClick={delContact}
                  >
                    删除其他联系人
                  </Button>
                </div>
              )}
              dataSource={contact || []}
              columns={getcolumns({
                dictionary,
                iptChange,
                contactSelectChange,
                disabled,
              })}
              pagination={false}
            />
          </div>
          <div className={style.sub_section}>
            <span className={style.sub_section_title}>售后信息</span>
          </div>
          <Form
            className="twoRow"
            form={afterSaleForm}
            name="basic"
            autoComplete="off"
          >
            <Row>
              <Col span={12}>
                <Form.Item
                  name="logistics_contactor"
                  label="收货人"
                  rules={[
                    {
                      required: get(requiredObj, "logistics_contactor"),
                    },
                  ]}
                >
                  <Input
                    allowClear
                    style={{ width: 380 }}
                    placeholder="请填写"
                    disabled={disabled}
                    maxLength={20}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="logistics_tel"
                  label="联系手机"
                  rules={[
                    {
                      required: get(requiredObj, "logistics_tel"),
                      validator: async (rule, value) => {
                        if (testPhoneNum(value)) {
                          throw new Error("请输入正确的手机号!");
                        }
                      },
                    },
                  ]}
                >
                  <Input
                    allowClear
                    style={{ width: 380 }}
                    placeholder="请填写"
                    disabled={disabled}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="address"
                  label={getRequiredIcon(
                    "售后地址",
                    get(requiredObj, "logistics_province") ||
                      get(requiredObj, "logistics_city") ||
                      get(requiredObj, "logistics_district") ||
                      get(requiredObj, "logistics_address"),
                  )}
                  // rules={[{ required: true, }]}
                >
                  <Input.Group compact>
                    <Form.Item
                      name={"address_cascader"}
                      noStyle
                      rules={[
                        {
                          required:
                            get(requiredObj, "logistics_province") ||
                            get(requiredObj, "logistics_city") ||
                            get(requiredObj, "logistics_district"),
                          message: "请选择省/市/区",
                        },
                      ]}
                    >
                      <Cascader
                        placeholder="请选择省/市/区"
                        style={{ width: 380 }}
                        options={addressArr}
                        fieldNames={{
                          label: "name",
                          value: "name",
                          children: "districts",
                        }}
                        allowClear
                        disabled={disabled}
                        changeOnSelect={false}
                      />
                    </Form.Item>
                    <Form.Item
                      name={"logistics_address"}
                      noStyle
                      rules={[
                        {
                          required: get(requiredObj, "logistics_address"),
                          message: "请输入详细地址",
                        },
                      ]}
                    >
                      <Input
                        allowClear
                        style={{ width: 540 }}
                        maxLength={200}
                        placeholder="请输入具体收货地址，精确到门牌号"
                        disabled={disabled}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div>
            <div className={style.sub_section}>
              <span className={style.sub_section_title}>收款账户信息</span>
            </div>
            {/* 境内企业，默认带出国内账户信息填写；
            境外企业，默认带出外汇账户信息填写。文案中的"**账户"也要是动态显示 */}
            <div style={{ marginBottom: "8px" }}>
              {get(params, "business_source_key") === jw && (
                <Button
                  type="link"
                  style={{ color: "orange", marginBottom: "8px" }}
                  onClick={() => {
                    addGNTTableData(false);
                  }}
                  disabled={disabled}
                >
                  如果需要点击添加国内账户
                </Button>
              )}
              {get(params, "business_source_key") === jn && (
                <Button
                  type="link"
                  style={{ color: "orange", marginBottom: "8px" }}
                  onClick={() => {
                    addOuterTableData(false);
                  }}
                  disabled={disabled}
                >
                  如果需要点击添加外汇账户
                </Button>
              )}
              {(get(params, "business_source_key") === jn ||
                get(GNTradeTableData, "length") > 0) && (
                <div style={{ marginBottom: "8px" }}>
                  <Table
                    rowKey={"uniqueId"}
                    rowSelection={GNTradeRowSelection}
                    title={() => (
                      <div>
                        国内账户{" "}
                        <Button
                          onClick={() => {
                            addGNTTableData();
                          }}
                          type="link"
                          disabled={disabled}
                        >
                          新增国内账户
                        </Button>
                        <Button
                          onClick={delGNTTTableData}
                          disabled={
                            !_.get(GNTradeRowSelectedKeys, "length") || disabled
                          }
                          type="link"
                        >
                          删除国内账户
                        </Button>
                      </div>
                    )}
                    dataSource={GNTradeTableData}
                    columns={getcolumns2({
                      setGNTAddress,
                      columns2BankNameChange,
                      columns2IptChange,
                      columns2BankFullNmeChange,
                      bankNameOptions,
                      finceArea,
                      disabled,
                      getBankOptions,
                    })}
                    pagination={false}
                  />
                </div>
              )}
            </div>
            <div>
              {(get(params, "business_source_key") === jw ||
                get(outerAccountTableData, "length") > 0) && (
                <div>
                  <Table
                    rowSelection={outerRowSelection}
                    rowKey={"uniqueId"}
                    title={() => (
                      <div>
                        外汇账户{" "}
                        <Button
                          onClick={() => {
                            addOuterTableData(false);
                          }}
                          type="link"
                          disabled={disabled}
                        >
                          新增外汇账户
                        </Button>
                        <Button
                          onClick={delOuterTableData}
                          disabled={
                            !_.get(outerRowSelectedKeys, "length") || disabled
                          }
                          type="link"
                        >
                          删除外汇账户
                        </Button>
                      </div>
                    )}
                    dataSource={outerAccountTableData || []}
                    columns={getcolumns3({
                      setOutAccountCurency,
                      columns3IptChange,
                      dictionary,
                      disabled,
                    })}
                    pagination={false}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};
export default forwardRef(SupplierInformation);



// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/supplierinformationentry/supplier-information.js